import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  resultPaperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 25,
    width: '90vw',
    zIndex: 999,
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 32px)',
      margin: '0 16px',
      minHeight: 'auto',
    },
  },
  diagramContainer: {
    padding: '15px 40px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      padding: '0',
      width: '100%',
      gap: 32,
    },
  },
  detailsContainer: {
    padding: '5px 50px',
    marginTop: '20px',
    '& p': {
      marginTop: '0px !important',
      marginBottom: '0px !important',
    },
    '& *': {
      fontFamily: 'Poppins !important',
      marginTop: '0px !important',
      marginBottom: '0px !important',
    },
  },
  shareLabelText: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 600,
    color: theme.palette.primary.light,
  },
  resultTextParagraph: {
    fontFamily: 'Poppins',
    fontSize: 26,
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#fff',
    zIndex: 99,
    '& p': {
      marginBottom: 10,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& *': {
      color: '#fff !important',
    },
  },
  labelLegend: {
    width: 32,
    height: 21,
    marginRight: 5,
    borderRadius: 4,
    flexShrink: 0,
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: 5,
    boxSizing: 'border-box',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    color: theme.palette.primary.dark,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    maxWidth: '100%',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      margin: '0 !important',
      justifyContent: 'flex-start !important',
    },
  },
  labelsGrid: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex !important',
      flexDirection: 'column !important',
      alignItems: 'stretch !important',
      justifyContent: 'center !important',
      width: 'fit-content !important',
      margin: '0 auto !important',
      marginTop: '32px !important',
      gap: '6px !important',
    },
  },
  variableImageContainer: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
  },
  diagramContent: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      padding: 0,
      width: '100%',
      display: 'flex !important',
      justifyContent: 'center !important',
      alignItems: 'center !important',
    },
  },
  button: {
    margin: '25px 0',
    color: '#fff',
    borderRadius: 4,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.main,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    width: '25%',
    [theme.breakpoints.down('md')]: {
      width: '45%',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
    '&:hover': {
      backgroundColor: '#fff',
      color: theme.palette.primary.light,
      border: `1px solid ${theme.palette.primary.light}`,
    },
    '&:focus': {
      background: '#fff',
      color: theme.palette.primary.light,
      border: `1px solid ${theme.palette.primary.light}`,
    },
  },
  studyRestitutionShareButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
  },
  studyRestitutionShareButton: {
    color: theme.palette.primary.main,
    borderRadius: 4,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: '#fff',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    width: 'fit-content',
    height: 30,
    marginTop: -6,
    marginLeft: 10,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: '#fff',
      border: `1px solid #fff`,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.dark,
      color: '#fff',
      border: `1px solid #fff`,
    },
  },
  shareIconsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  socialMediaIconsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  diagramContainerNew: {
    width: '100%',
  },
}));

export default useStyles;
